import { ActionContext } from "vuex";

const state = {
  isAuthenticate: false,
};

const getters = {
  isAuthenticate: (state: any) => state.isAuthenticate,
};

const actions = {
  setAuthenticate(context: ActionContext<any, any>, isAuthenticate: Boolean) {
    context.commit("SET_IS_AUTHENTICATE", isAuthenticate);
  },
};

const mutations = {
  SET_IS_AUTHENTICATE(state: any, isAuthenticate: Boolean) {
    state.isAuthenticate = isAuthenticate;
  },
};

const authenticate = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default authenticate;
